module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/italy_cn.5c8f2ec5.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/italy_cn.png
// module id = 1076
// module chunks = 16